// Student navigation context. Tracks current page within the student dashboard (home, classroom, games, etc).
import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

export type StudentPage = 'home' | 'classroom' | 'games' | 'safety' | 'profile' | 'notifications' | 'documentation';

interface StudentNavigationContextType {
  currentPage: StudentPage;
  setCurrentPage: (page: StudentPage) => void;
}

const StudentNavigationContext = createContext<StudentNavigationContextType | undefined>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const useStudentNavigation = () => {
  const context = useContext(StudentNavigationContext);
  if (!context) {
    throw new Error('useStudentNavigation must be used within StudentNavigationProvider');
  }
  return context;
};

interface StudentNavigationProviderProps {
  children: ReactNode;
}

export const StudentNavigationProvider = ({ children }: StudentNavigationProviderProps) => {
  const [currentPage, setCurrentPage] = useState<StudentPage>('home');

  const contextValue: StudentNavigationContextType = {
    currentPage,
    setCurrentPage,
  };

  return (
    <StudentNavigationContext.Provider value={contextValue}>
      {children}
    </StudentNavigationContext.Provider>
  );
};